import { NotificationConfiguration } from '../notification.templates';

export const MEETING_MINUTES_REVIEW_REQUEST: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> asks you to review meeting minutes.`,
  email: {
    ctaKey: 'go_to_meeting_minutes',
  },
};
